<template>
    <div id="contes">
        <div id="cesiumContainer">
            <div class="cesium1-btn">
                2020/03/20
                <!-- <el-select v-model="value" size="mini" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select> -->
            </div>
        </div>
        <div id="cesiumContainer2">
            <div class="cesium2-btn">
                <el-select v-model="value1" size="mini" @change="change1" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div id="cesiumContainer3">
            <div class="cesium3-btn">
                <el-select v-model="value2" size="mini" @change="change2" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../components/util';
import * as L from 'leaflet'
import CesiumOverviewMapControl from "../../js/OverviewMapControl"
export default {
    data () {
        return {
            maps1: '',
            maps2: '',
            maps3: '',
            options: [],
            value1: '20020915',
            value2: '20130921'
        }
    },
    mounted(){
        this.options = [{
                value: '//www.smartearthx.com/yayun/tiles/20020915/{z}/{x}/{y}.png',
                label: '2002/09/15'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20030913/{z}/{x}/{y}.png',
                label: '2003/09/13'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20050414/{z}/{x}/{y}.png',
                label: '2005/04/14'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20050818/{z}/{x}/{y}.png',
                label: '2005/08/18'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20060427/{z}/{x}/{y}.png',
                label: '2006/04/27'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20070217/{z}/{x}/{y}.png',
                label: '2007/02/17'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20080525/{z}/{x}/{y}.png',
                label: '2008/05/25'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20080719/{z}/{x}/{y}.png',
                label: '2008/07/19'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20090629/{z}/{x}/{y}.png',
                label: '2009/06/29'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20100514/{z}/{x}/{y}.png',
                label: '2010/05/14'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20120915/{z}/{x}/{y}.png',
                label: '2012/09/15'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20130921/{z}/{x}/{y}.png',
                label: '2013/09/21'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20140903/{z}/{x}/{y}.png',
                label: '2014/09/03'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20150702/{z}/{x}/{y}.png',
                label: '2015/07/02'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20160507/{z}/{x}/{y}.png',
                label: '2016/05/07'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20170525/{z}/{x}/{y}.png',
                label: '2017/05/25'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20180426/{z}/{x}/{y}.png',
                label: '2018/04/26'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20191124/{z}/{x}/{y}.png',
                label: '2019/11/24'
            }, {
                value: '//www.smartearthx.com/yayun/tiles/20200320/{z}/{x}/{y}.png',
                label: '2020/03/20'
            }]
        this.init();
    },
    methods:{
        init(){
            this.maps1=util.getViewer('cesiumContainer',{
                geocoder: new OpenStreetMapNominatimGeocoder()
            });
            function OpenStreetMapNominatimGeocoder() {
            }
            OpenStreetMapNominatimGeocoder.prototype.geocode = function(input) {
                var endpoint = 'https://nominatim.openstreetmap.org/search';
                var resource = new Cesium.Resource({
                    url: endpoint,
                    queryParameters: {
                        format: 'json',
                        q: input
                    }
                });

                return resource.fetchJson()
                    .then(function(results) {
                        var bboxDegrees;
                        return results.map(function(resultObject) {
                            bboxDegrees = resultObject.boundingbox;
                            return {
                                displayName: resultObject.display_name,
                                destination: Cesium.Rectangle.fromDegrees(
                                    bboxDegrees[2],
                                    bboxDegrees[0],
                                    bboxDegrees[3],
                                    bboxDegrees[1]
                                )
                            };
                        });
                    });
            };

            this.maps2=util.getViewer('cesiumContainer2',{
                baseLayerPicker: false
            });

            this.maps3=util.getViewer('cesiumContainer3',{
                baseLayerPicker: false
            });

            var layer = this.maps1.imageryLayers.addImageryProvider(
                new Cesium.UrlTemplateImageryProvider({
                    url: "//www.smartearthx.com/yayun/tiles/20200320/{z}/{x}/{y}.png",
                    minimumLevel: 12,
                    maximumLevel: 18,
                    tileWidth: 256,
                    tileHeight: 256,
                    credit: "lingtu",
                    rectangle: Cesium.Rectangle.fromDegrees(116.378173828125,
                        39.9847412109375,
                        116.39808654785156,
                        40.010833740234375),
                    format: 'image/png'
                })
            );

            var layer2 = this.maps2.imageryLayers.addImageryProvider(
                new Cesium.UrlTemplateImageryProvider({
                    url: "//www.smartearthx.com/yayun/tiles/20020915/{z}/{x}/{y}.png",
                    minimumLevel: 12,
                    maximumLevel: 18,
                    tileWidth: 256,
                    tileHeight: 256,
                    credit: "lingtu",
                    rectangle: Cesium.Rectangle.fromDegrees(116.378173828125,
                        39.9847412109375,
                        116.39808654785156,
                        40.010833740234375),
                    format: 'image/png'
                })
            );

            var layer3 = this.maps3.imageryLayers.addImageryProvider(
                new Cesium.UrlTemplateImageryProvider({
                    url: "//www.smartearthx.com/yayun/tiles/20130921/{z}/{x}/{y}.png",
                    minimumLevel: 12,
                    maximumLevel: 18,
                    tileWidth: 256,
                    tileHeight: 256,
                    credit: "lingtu",
                    rectangle: Cesium.Rectangle.fromDegrees(116.378173828125,
                        39.9847412109375,
                        116.39808654785156,
                        40.010833740234375),
                    format: 'image/png'
                })
            );


            // layer2.imageryProvider.url = "http://172.17.13.22:8083/tiles/20200320/{z}/{x}/{y}.png";

            this.maps1.camera.flyTo({
                destination : Cesium.Cartesian3.fromDegrees( 116.38813018798828, 39.99778747558594,
                    5000),
                orientation : {
                    heading : Cesium.Math.toRadians(0.0),
                    pitch : Cesium.Math.toRadians(-90.0),
                    roll : 0.0
                }
            });



            following(this.maps2, this.maps1);
            following(this.maps3, this.maps1);
            function following(maps1, maps2) {
                let viewer = maps1;
                let control = viewer.scene.screenSpaceCameraController;
                control.enableRotate = false;
                control.enableTranslate = false;
                control.enableZoom = false;
                control.enableTilt = false;
                control.enableLook = false;
                let syncViewer = function () {
                    viewer.camera.flyTo({
                        destination: maps2.camera.position,
                        orientation: {
                            heading: maps2.camera.heading,
                            pitch: maps2.camera.pitch,
                            roll: maps2.camera.roll,
                        },
                        duration: 0.0,
                    });
                };
                viewer.entities.add({
                    position: Cesium.Cartesian3.fromDegrees(0, 0),
                    label: {
                        text: new Cesium.CallbackProperty(function () {
                            syncViewer();
                            return "";
                        }, true),
                    },
                });
            };



        },
        change1(e) {
            console.log(e);
            this.changeTile(this.maps2, this.value1);
        },
        change2(e) {
            console.log(e);
            this.changeTile(this.maps3, this.value2);
        },
        changeTile(maps2, url){
                let layer2 = maps2.imageryLayers.addImageryProvider(
                    new Cesium.UrlTemplateImageryProvider({
                        url: url,
                        minimumLevel: 12,
                        maximumLevel: 18,
                        tileWidth: 256,
                        tileHeight: 256,
                        credit: "lingtu",
                        rectangle: Cesium.Rectangle.fromDegrees(116.378173828125,
                            39.9847412109375,
                            116.39808654785156,
                            40.010833740234375),
                        format: 'image/png'
                    })
                );


            }

    }
}
</script>
<style lang="stylus" scoped>
    #contes{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
    }
    #cesiumContainer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
        border-right: 1px solid #fff;
    }
    #cesiumContainer2 {
        position: absolute;
        left: 50%;
        top: 0;
        width: 50%;
        height: 50%;
        margin: 0;
        padding: 0;
        overflow: hidden;
        z-index: 500;
        border-bottom: 1px solid #fff;
    }
    #cesiumContainer3 {
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 50%;
        height: 50%;
        margin: 0;
        padding: 0;
        overflow: hidden;
        z-index: 500;
    }
    .cesium1-btn {
        position: absolute;
        z-index: 10;
        top: 5px;
        left: 8px;
        font-size: 30px;
        color: #f8f8fd;
    }
    .cesium2-btn {
        position: absolute;
        z-index: 10;
        top: 10px;
        right: 10px;
    }
    .cesium3-btn {
        position: absolute;
        z-index: 10;
        top: 10px;
        right: 10px;
    }
</style>
